import {
  SIGNUP_SURVEY_COMPLETE_SUBTITLE,
  SURVEY_ALREADY_SUBMITTED_SUBTITLE,
  SURVEY_COMPLETE_NO_REWARD_THANK_YOU,
  SURVEY_COMPLETE_THANK_YOU,
  WEB_SURVEY_COMPLETE_PARTICIPATION,
} from './survey-completion-messages'

export function surveyCompletionSubtitle(opts: {
  readonly isAlreadySubmitted: boolean
  readonly hasReward: boolean
  readonly showWebSurveyRewardCta: boolean
  readonly surveyFirstJourney: boolean
  readonly signupSurveyMode: boolean
}): string {
  if (opts.isAlreadySubmitted) {
    return SURVEY_ALREADY_SUBMITTED_SUBTITLE
  }
  if (!opts.hasReward && !opts.showWebSurveyRewardCta) {
    return SURVEY_COMPLETE_NO_REWARD_THANK_YOU
  }
  if (opts.surveyFirstJourney) {
    return WEB_SURVEY_COMPLETE_PARTICIPATION
  }
  if (opts.signupSurveyMode) {
    return SIGNUP_SURVEY_COMPLETE_SUBTITLE
  }
  return SURVEY_COMPLETE_THANK_YOU
}
